import { useCallback, useEffect, useState } from "react";

import { readJson, writeJson } from "@/utils/storage";

const KEY = "portal:favorites";

export function useFavorites() {
  const [ids, setIds] = useState<string[]>(() => readJson<string[]>(KEY, []));

  useEffect(() => {
    writeJson(KEY, ids);
  }, [ids]);

  const toggle = useCallback((id: string) => {
    setIds((prev) =>
      prev.includes(id) ? prev.filter((i) => i !== id) : [...prev, id],
    );
  }, []);

  const isFavorite = useCallback((id: string) => ids.includes(id), [ids]);

  return { favorites: ids, toggle, isFavorite };
}
